
export const reloadReducer = (state = false, action) => {
    switch(action.type){
        case "reload/set": {
            return action.payload;
        }
        default:
            return state
    }
}